import { useEffect, useState } from "react"
import ClientData, { type Fontdata } from "@/common/client_data"
import { type SignStateData } from "@/signomatic/app/sign"
import type Sign from "@/signomatic/app/sign"

export interface MinimaticSignState {
  signType: string
  metaProduct?: string | null
  fabricJson: any
}

export interface MinimaticSignData {
  signData: SignData[]
  fontData: Fontdata
  metaProducts: string[]
}

export interface MinimaticData {
  text1?: string
  text2?: string
  text3?: string
  textColor?: string
  color?: string
  contentColor?: string
  font?: string
  fixmethod?: string
}

export async function loadMinimatic(sign: MinimaticSignState, data: MinimaticSignData, skipGlobal = false) {
  // TODO: Refactor out this clientdata usage, Sign should have a public API for this and not use clientdata for these.
  ClientData.update({
    sign_data: data.signData,
    fontdata: data.fontData,
    meta_products: data.metaProducts,
    load_sign: sign.fabricJson,
  })

  const Sign = (await import("@/signomatic/app/sign")).default
  const minimatic = new Sign(true, false, data.fontData, skipGlobal)

  if (sign.metaProduct) {
    minimatic.setMetaSignType(sign.metaProduct, sign.signType)
  } else if (sign.signType !== "root") {
    minimatic.setSignType(sign.signType)
  }

  return minimatic
}

export const useMinimaticLoaded = (minimatic?: Sign) => {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (!minimatic) {
      return
    }

    const handleLoad = () => setLoaded(true)

    minimatic.onLoad.subscribe(handleLoad)

    if (minimatic.isLoaded) {
      handleLoad()
    }

    return () => minimatic.onLoad.unsubscribe(handleLoad)
  }, [minimatic, setLoaded])

  return loaded
}

export const useMinimaticData = (handler: (data: SignStateData) => void, minimatic?: Sign) => {
  useEffect(() => {
    if (minimatic) {
      minimatic.onSignDataChanged.subscribe(handler)

      if (minimatic.isLoaded) {
        handler({ state: minimatic.state, data: minimatic.validatedData })
      }

      return () => minimatic.onSignDataChanged.unsubscribe(handler)
    }

    return
  }, [minimatic, handler])
}
